<template>
  <DBox
    :id="'cmp-distribution-statement-sidewindow-cost'"
    :addButton="false"
    :addLink="false"
  >
    <!-- @add_click="onAddArtist" -->
    <!-- :expandable="true" -->
    <NTable
      class="dbox1"
      id="distribution-statement-cost"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('cost')">
            <span class="txtov">{{ item['release_title'] }}</span>
          </td>
          <td v-bind="tdcon('identifier')">
            <span class="txtov">{{ item['identifier'] }}</span>
          </td>
          <td v-bind="tdcon('group')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :disabled="false"
              :options="costGroupTV"
              :selected="costGroupTV.find(v => v.value == item.cost_group_id)"
              :placeholder="$t('group')"
              v-on:selectedChange="e => onDropdownChange(item, e)"
              :bb="'0px'"
            />
          </td>
          <td v-bind="tdcon('description')">
            <span class="txtov">{{ item['cost_description'] }}</span>
          </td>
          <td v-bind="tdcon('amount')">
            <span>{{ item['cost_pu'] }}</span>
          </td>
          <td v-bind="tdcon('currency')">
            <span>{{ item['currency'] }}</span>
          </td>
          <td v-bind="tdcon('stmt_cost_pu')">
            <span>{{ parseFloat(item['stmt_cost_pu']).toFixed(2) }}</span>
          </td>
          <td v-bind="tdcon('option')">
            <img
              src="static/icons/delete.svg"
              @click.stop="(e) => onDelete(item)"
              class="dt-icon v5 s2 ut-center"
              alt
            />
          </td>

        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { createTV } from '../../../../models/text-value.model';

export default {
  props: {
    selectedStatementDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("cost", {}),
        createTableHeader("identifier", {}),
        createTableHeader("group", { }),
        createTableHeader("description", { }),
        createTableHeader("amount", { ta:'right' }),
        createTableHeader("currency", { mw:65 }),
        createTableHeader("stmt_cost_pu", { text:'EUR' , ta:'right'}),
        createTableHeader("option", { text:false ,mw:30}),
        
      ];
    },
    costGroupTV:function(){
      return createTV(this.selectedStatementDetails?.cost_groups,'cost_group_name','cost_group_id');
    },

    list: function() {
      return this.selectedStatementDetails.cost_details || [];
    },


  },
  methods: {
    onDelete:function(item){

    },

    onDropdownChange:function(item, e){
      //console.log(item,"item")
      const kVal = item.statement_line_id;
      const value = e.value;
      //console.log(e,"e")

      this.$emit('update',{value,objKey:'cost_details' ,kVal})

    },

    onDelete:function(item){
      console.log(item)
      const { statement_line_id } = item;

      this.$emit('delete',{objKey:'cost_details' ,statement_line_id:statement_line_id ,statement_id:this.selectedStatementDetails.statement.statement_id})

    }
  }
};
</script>
